(function () {

    function initAccordion(accordion) {

        if (accordion.dataset.initialized === 'true') {
            return;
        }

        accordion.dataset.initialized = 'true';

        const items = Array.from(
            accordion.querySelectorAll(
                '[data-accordion-item]'
            )
        );

        const allowMultiple =
            accordion.dataset.allowMultiple === 'true';

        items.forEach((item) => {

            const trigger = item.querySelector(
                '[data-accordion-trigger]'
            );

            if (!trigger) {
                return;
            }

            trigger.addEventListener('click', function () {

                const currentlyOpen =
                    item.classList.contains('is-open');

                /*
                 * Normal accordion:
                 * close other items first.
                 */
                if (!allowMultiple) {

                    items.forEach((otherItem) => {

                        if (otherItem === item) {
                            return;
                        }

                        otherItem.classList.remove('is-open');

                        const otherTrigger =
                            otherItem.querySelector(
                                '[data-accordion-trigger]'
                            );

                        if (otherTrigger) {
                            otherTrigger.setAttribute(
                                'aria-expanded',
                                'false'
                            );
                        }

                    });

                }

                item.classList.toggle(
                    'is-open',
                    !currentlyOpen
                );

                trigger.setAttribute(
                    'aria-expanded',
                    currentlyOpen ? 'false' : 'true'
                );

            });

        });

    }


    function initAllAccordions(scope = document) {

        scope
            .querySelectorAll('[data-accordion]')
            .forEach(initAccordion);

    }


    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            function () {
                initAllAccordions();
            }
        );

    } else {

        initAllAccordions();

    }


    /*
     * ACF preview.
     */

    if (window.acf) {

        window.acf.addAction(
            'render_block_preview/type=filtronic/accordion',
            function ($block) {

                $block
                    .find('[data-accordion]')
                    .each(function () {
                        initAccordion(this);
                    });

            }
        );

    }

})();